import { useState } from "react"

type UseAvatarUploadReturn = {
  avatarFile: File | null
  avatarPreview: string | null
  handleAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  resetAvatar: () => void
}

const useAvatarUpload = (): UseAvatarUploadReturn => {
  const [avatarFile, setAvatarFile] = useState<File | null>(null)
  const [avatarPreview, setAvatarPreview] = useState<string | null>(null)

  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setAvatarFile(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setAvatarPreview(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }

  const resetAvatar = () => {
    setAvatarFile(null)
    setAvatarPreview(null)
  }

  return { avatarFile, avatarPreview, handleAvatarChange, resetAvatar }
}

export default useAvatarUpload
